"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Xavier = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardRenderItem_1 = require("../render/CardRenderItem");
class Xavier extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.XAVIER,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L24',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.REQ).colon().megacredits(-1).asterix();
                    b.br.br;
                    b.opgArrow().text('GAIN').nbsp().wildTag(2).played.nbsp().asterix();
                }),
                description: 'Once per game, gain 2 wild tags for THIS GENERATION. Cards with requirements cost you 1 M€ less to play AFTER this action has been used.',
            },
        });
        this.isDisabled = false;
        this.opgActionIsActive = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action() {
        this.opgActionIsActive = true;
        this.isDisabled = true;
        return undefined;
    }
    getCardDiscount(_player, card) {
        if (this.isDisabled && card.requirements !== undefined)
            return 1;
        return 0;
    }
}
exports.Xavier = Xavier;
//# sourceMappingURL=Xavier.js.map